import React, { Component } from 'react';
import { connect } from 'react-redux';
// components
import SearchBody from './SearchBody';
// icons
import { Icon } from '../../Components/Icons/Icons';
// styles
import { SearchWrap, SearchToggle } from './style';
import { SearchUsersActionCreators } from '../../../Store/ActionCreators/SearchUsersActionCreators';

class Search extends Component {
    state = {
        opened: false,
    };

    get body() {
        return <SearchBody open={this.state.opened} handleClose={this.handleToggle('close')} />;
    }

    handleToggle = type => () => {
        if (type === 'open') {
            this.props.getAllUsers();
            return this.setState({ opened: true });
        }

        this.setState({ opened: false });
    };

    render() {
        return (
            <SearchWrap>
                <SearchToggle onClick={this.handleToggle('open')}>
                    <Icon.Box size={'22x23'}>
                        <Icon.SearchLoop />
                    </Icon.Box>
                </SearchToggle>
                {this.body}
            </SearchWrap>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    getAllUsers: (filter, offset_id) => dispatch(SearchUsersActionCreators.getUsers(filter, offset_id)),
});

export default connect(
    null,
    mapDispatchToProps,
)(Search);



// WEBPACK FOOTER //
// ./src/UI/Containers/Search/index.js